import { isMobile, isInApp, getQueryString } from '@/utils/tools'
import { useStore } from 'vuex'

export const BUSINESS_NAME = '问卷系统'

// 埋点初始化
export const useInitBurying = (
  orgid,
  memberid = '', isAutotrack = true
) => {

  window.collectEvent('init', {
    app_id: 10000166,
    channel_domain: 'https://app-finder.litenews.cn',
    log: false,
    autotrack: isAutotrack,
  })
  window.collectEvent('start')

  const channel = isInApp() ? '客户端' : (isMobile() ? 'h5' : 'PC端')
  // const token = localStorage.getItem('token')

  window.collectEvent('config', {
    app_org_id: orgid,
    app_org_cate: orgid,        
		app_org_id1: orgid,        
		app_org_id2: orgid,          
		app_org_id3: orgid,          
    // business_name: BUSINESS_NAME,
    big_activity_id: getQueryString('questionActiveKey'),
    big_activity_source_channel: channel,
    // big_activity_login_status: token ? '登录' : '未登录',
  })
  if (memberid) {
    window.collectEvent('config', {
      user_unique_id: memberid,
    })
  }
}

// 触发埋点事件
export const handleBuryingEvent = (eventName, params) => {
  window.collectEvent(eventName, params)
}

// 问卷访问pv
export const useQuesPageview = ({
  quesTitle,
  quesType,
  pageType = `首页`
}) => {
  let event = 'bm_page_access'

  if (quesType === 1) {
    event = 'bm_page_access'
  } else if (quesType === 3) {
    event = 'question_activities_access'
  }

  handleBuryingEvent(event, {
    big_activity_name: quesTitle,
    big_activity_page_type: pageType
  })
}

// 大活动页面pv
export const useBigActivityPageview = ({
  quesTitle,
  quesType,
  pageType = `${BUSINESS_NAME}首页`
}) => {
  let quesString = '问卷'
  if (quesType ===2) {
    quesString = '满意度'
  } else if (quesType === 3) {
    quesString = '答题'
  }

  handleBuryingEvent('big_activity_pageview', {
    big_activity_name: quesTitle,
    ques_type: quesString,
    big_activity_page_type: pageType
  })
}

// 答题首页按钮点击
export const useStartBtnClick = ({buttonName, quesTitle}) => {

  handleBuryingEvent('question_activities_participate', {
    big_activity_button_name: buttonName,
    big_activity_name: quesTitle,
  })
}

// 点击提交按钮事件
export const useSubmitBtnClick = ({
  quesTitle,
  quesType,
  btnName,
  status = '成功'
}) => {
  let event = 'complete_questionnaire_registration'

  if (quesType === 1) {
    event = 'complete_questionnaire_registration'
  } else if (quesType === 3) {
    event = 'complete_question'
  }

  const params = {
    big_activity_name: quesTitle,
    big_activity_api_status: status
  }

  if (btnName) {
    params.big_activity_button_name = btnName
  }

  handleBuryingEvent(event, params)
}